const initialState = {
    isReadingContacts: false,
    contacts: [],
    count: 0,
    contactBeingUpdated: null
}

export default initialState;
